import { InputNumber } from "antd";

export function QtyInput({
  value,
  onChange,
  unit,
  min = 0,
  max,
  placeholder,
}: {
  value?: number;
  onChange?: (v: number | null) => void;
  unit?: string;
  min?: number;
  max?: number;
  placeholder?: string;
}) {
  return (
    <InputNumber
      value={value}
      onChange={onChange}
      min={min}
      max={max}
      step={0.001}
      precision={3}
      style={{ width: "100%" }}
      addonAfter={unit}
      placeholder={placeholder}
    />
  );
}
